export const viewsMap = {
  FRONT: 'front',
  INSIDE: 'inside',
  BACK: 'back',
  OTHERS: 'others',
};
